import { useCallback, useEffect, useMemo, useRef, useState, MouseEvent } from 'react';
import { GeoJsonLayerPickingInfo } from './types';
import useDeckGlMapStyles from './styles';
import { fallbackGetTooltip } from './MapTooltip';

export function GeoJsonLayerTooltip({
  info,
  width,
  height,
}: {
  info: GeoJsonLayerPickingInfo;
  width: number;
  height: number;
}) {
  const { object, x, y } = info;
  const getTooltip = info?.layer?.props?.getLayerTooltip ?? fallbackGetTooltip;

  // Get the tooltip content
  const tooltipContent = useMemo(() => {
    return getTooltip(info);
    // watch the object so we can update the tooltip
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [object, getTooltip]);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [tooltipSize, setTooltipSize] = useState({ width: 0, height: 0 });
  const classes = useDeckGlMapStyles();

  useEffect(() => {
    let refTimer = setTimeout(() => {
      if (tooltipRef.current) {
        const { width, height } = tooltipRef.current.getBoundingClientRect();
        if (width === 0 || height === 0 || !tooltipContent || tooltipContent?.length === 0) {
          return;
        }
        setTooltipSize({ width, height });
        clearTimeout(refTimer);
      }
    }, 100);
    return () => clearTimeout(refTimer);
  }, [tooltipContent]);

  const maxLeft = width - tooltipSize.width * 1.1;
  const maxTop = height - tooltipSize.height * 1.1;
  let left = x + 10;
  let top = y + 10;
  if (left > maxLeft) {
    left = maxLeft;
  }
  if (top > maxTop) {
    top = maxTop;
  }
  const stopEventPropagation = useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  }, []);
  return (
    <div
      className={classes.deckGlMapTooltip}
      autoFocus
      onMouseMoveCapture={stopEventPropagation}
      onMouseDownCapture={stopEventPropagation}
      style={{
        visibility: tooltipSize.width > 0 ? 'visible' : 'hidden',
        left,
        top,
      }}
      ref={tooltipRef}
    >
      <div
        dangerouslySetInnerHTML={{ __html: tooltipContent ?? '' }}
        className={classes.geoJsonInnerMapTooltip}
      ></div>
    </div>
  );
}
